<!--
 * @Author: cmchiu
 * @Date: 2023-05-02 16:38:47
 * @LastEditTime: 2023-06-02 14:02:20
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \IACMP\IACMP_Client\src\components\Breadcrumb\breadcrumb.vue
 * 
-->
<template>
    <!-- Breadcrumb -->
    <div class="breadcrumb w-100">
        <div class="layer-container">
            <span v-for="(item, index) in levelList" :key="item.path">
                <template
                    v-if="
                        (item.redirect === 'noRedirect' || index == levelList.length - 1) &&
                            item.parent.redirect != item.path &&
                            item.parent.redirect != '/home'
                    "
                >
                    <router-link
                        class="breadcrumb__link"
                        :to="{ path: item.parent.redirect, query: { id: $route.query.id } }"
                        v-html="item.parent.meta.title"
                    ></router-link>
                    <span class="breadcrumb__separate">/</span>
                </template>
                <span
                    class="breadcrumb__link"
                    v-if="item.redirect === 'noRedirect' || index == levelList.length - 1"
                    v-text="!title ? item.meta.title : title"
                ></span>
                <template v-else>
                    <router-link class="breadcrumb__link" :to="{ path: '/home' }" v-text="'首頁'"></router-link>
                    <span class="breadcrumb__separate">/</span>
                </template>
            </span>
        </div>
    </div>
</template>

<script>
import pathToRegexp from 'path-to-regexp'

export default {
    name: 'breadcrumb',

    props: {
        title: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            levelList: null,
        }
    },

    created() {
        this.getBreadcrumb()
    },

    methods: {
        getBreadcrumb() {
            // only show routes with meta.title
            let matched = this.$route.matched.filter(item => item.meta && item.meta.title)
            // const first = matched[0]

            // if (/* !this.isDashboard(first) */ !first.parent) {
            //     // matched = [{ path: '/home', meta: { title: '首頁' } }].concat(matched)
            //     first.meta.title = '首頁'
            //     // first.redirect = '/home'
            // }

            this.levelList = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
        },
        isDashboard(route) {
            const name = route && route.name
            if (!name) {
                return false
            }
            return name.trim().toLocaleLowerCase() === '0000'.toLocaleLowerCase()
        },
        pathCompile(path) {
            // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
            const { params } = this.$route
            var toPath = pathToRegexp.compile(path)
            return toPath(params)
        },
        handleLink(item) {
            const { redirect, path } = item
            if (redirect) {
                this.$router.push(redirect)
                return
            }
            this.$router.push(this.pathCompile(path))
        },
    },
}
</script>

<style lang="scss" scoped>
.breadcrumb {
    height: -moz-fit-content;
    height: fit-content;
    padding: 16px 0;
    /* padding-top: 100px; */
    background-color: #585455;
    letter-spacing: 1.5px;
}
.breadcrumb__link {
    color: #ffffff;
    font-size: 16px;
}
.breadcrumb__separate {
    padding: 0 6px;
    color: #ffffff;
}
@media (max-width: 1365px) {
    .breadcrumb {
        padding: 7px 0;
        /* padding-top: 73px; */
    }
    .breadcrumb__link {
        font-size: 14px;
    }
}
</style>
